import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { PersonaSelectionPopup } from './PersonaSelectionPopup';

export const PERSONA_SELECTION_POPUP = Symbol('PERSONA_SELECTION');

export const useSelectPersonaPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(PERSONA_SELECTION_POPUP, PersonaSelectionPopup);
  });

  /**
   * Display persona selection popup
   * @param {Object} options
   * @param {Function} options.onSubmit - callback to be called when selection gets confirmed
   * @param {boolean} options.displaySuggested - whether to display suggested personas
   * @returns {Promise}
   */
  return useCallback(
    ({ language, displaySuggested = false }) => {
      return new Promise((resolve) => {
        popups.openPopup(PERSONA_SELECTION_POPUP, {
          language,
          displaySuggested,

          onSubmit: (result) => {
            popups.closePopup(PERSONA_SELECTION_POPUP);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(PERSONA_SELECTION_POPUP);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
